import React from 'react'
import { i18nText } from '../../../Services'

export const HelpText = props => {
    const text = props.text || (props.element ? props.element.text : "");
    
    return (
        <>
            { i18nText.exists(text) && <small className="text-muted">{i18nText.getText(text)}</small> }
        </>
    )
}

export default HelpText;